import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import './index.css';
import App from './App.js';
import ErrorBoundary from './components/ErrorBoundary.js';
import reportWebVitals from './reportWebVitals.js';

// Suppress the benign ResizeObserver loop warning that React's error overlay
// treats as an error. This is a known browser quirk, not a real error.
window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ChakraProvider>  {/* Wrap App inside ChakraProvider */}
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </ChakraProvider>
  </React.StrictMode>
);

reportWebVitals();
